// ProductDetail.js
'use client';
import { connect } from 'react-redux';

import {
  PUBLIC_PRODUCT_URL_PATH,
  MESSAGE_PACK_FEED_ALIAS,
  HELP_ARTICLE_ID_MESSAGE_PACK,
  HELP_ARTICLE_LINK_MESSAGE_PACK,
  FAQ_SUPPORTED_LANGUAGES,
} from '../RemoteConfigKeys.js';
import { MERGE_OPERATION_DATA } from '../ActionTypes.js';

import ProductDetail from '../page/ProductDetail.jsx';

import withRouter from '../component/WithRouter.jsx';

import getMeData from '../selector/getMeData.js';
import getRemoteConfigData from '../selector/getRemoteConfigData.js';
import getListData from '../selector/getListData.js';
import getNetworkingData from '../selector/getNetworkingData.js';
import getFeedName from '../selector/getFeedName.js';
import getOperationData from '../selector/getOperationData.js';
import getDiamondPackData from '../selector/getDiamondPackData.js';
import getProductData from '../selector/getProductData.js';
import getTimestampOffset, {
  Accuracy,
} from '../selector/getTimestampOffset.js';

import fetchOrders from '../action/fetchOrders.js';
import toggleModal from '../action/toggleModal.js';
import login from '../action/login.js';
import buyProduct from '../action/buyProduct.js';

import { Entry } from '../resource/loginRegisterConstants.js';
import { getFeedNameType } from '../resource/feedUtils.js';
import { OrderStatus, ProductType } from '../resource/shopConstants.js';
import withFetchProductData from '../resource/withFetchProductData.js';
import withSelectSkuId from '../resource/withSelectSkuId.js';
import { getCurrentFaqLanguage } from '../resource/getCurrentLanguage.js';

const mapStateToProps = (
  state,
  {
    match: {
      params: { productId },
    },
    i18n,
  }
) => {
  const shopId = getOperationData(state, ['shop'], 'usingShopId');
  const selectedSkuId = getOperationData(
    state,
    ['shop', shopId],
    'selectedDiamondPackId'
  );
  const productType = getProductData(state, [productId], 'type');
  const feedName =
    ProductType.MESSAGEPACKS === productType
      ? getFeedName(state, MESSAGE_PACK_FEED_ALIAS, '{PRODUCT_ID}', productId)
      : undefined;
  const listSelectPath = ['home', getFeedNameType({ feedName }), feedName];
  const modifiers = getDiamondPackData(state, selectedSkuId, 'modifiers');
  const { discountedFrom } = modifiers || {};
  const sourceJointId = getOperationData(
    state,
    ['shop', shopId],
    'selectPaymentSourceJointId'
  );
  const articleConfigKey =
    ProductType.MESSAGEPACKS === productType
      ? HELP_ARTICLE_ID_MESSAGE_PACK
      : undefined;

  const articleSupportedLanguages = getRemoteConfigData(
    state,
    FAQ_SUPPORTED_LANGUAGES
  );
  const language = getCurrentFaqLanguage({
    i18n,
    supportedLanguages: articleSupportedLanguages,
  });

  const articleUrl = getRemoteConfigData(
    state,
    HELP_ARTICLE_LINK_MESSAGE_PACK,
    undefined,
    { LOWER_CASE_LANG: language }
  );

  return {
    articleConfigKey,
    formattedArticleLink: articleUrl,
    meId: getMeData(state, 'id'),
    publicProductUrlPath: getRemoteConfigData(state, PUBLIC_PRODUCT_URL_PATH),
    feedName,
    productId,
    shopId,
    selectedSkuId,
    productType,
    currency: getOperationData(state, ['shop'], 'currency'),
    messageIds: getListData(state, listSelectPath, 'itemIds'),
    boughtProductIds: getListData(
      state,
      ['order', OrderStatus.BOUGHT, productType, 'productIds'],
      'itemIds'
    ),
    totalCount: getListData(state, listSelectPath, 'totalCount'),
    productNbf: getProductData(state, [productId], 'nbf'),
    productExp: getProductData(state, [productId], 'exp'),
    timestampOffsetSeconds: getTimestampOffset(state, Accuracy.SECOND),
    discountedFrom,
    price: getDiamondPackData(state, selectedSkuId, 'price'),
    soldCount: getDiamondPackData(state, selectedSkuId, 'soldCount'),
    isProductDetailFetching: !!getNetworkingData(
      state,
      ['fetch', 'product', productId],
      'isFetching'
    ),
    isBoughtOrderFetching: !!getNetworkingData(
      state,
      ['fetch', 'order', OrderStatus.BOUGHT, productType, 1, productId],
      'isFetching'
    ),
    isOrderSubmitting: !!getNetworkingData(
      state,
      ['shop', shopId, 'submitOrder'],
      'isFetching'
    ),
    isCompleteOrderSubmitting: !!getNetworkingData(
      state,
      ['shop', shopId, 'completeOrder', sourceJointId],
      'isFetching'
    ),
    secondaryBadge: getDiamondPackData(state, selectedSkuId, 'secondaryBadge'),
    shopColorBadges: getRemoteConfigData(state, 'shopColorBadges'),
  };
};

const mapDispatchToProps = dispatch => {
  return {
    fetchOrders: data => dispatch(fetchOrders(data)),
    buyProduct: data => dispatch(buyProduct(data)),
    toggleModal: data => dispatch(toggleModal(data)),
    login: () => {
      dispatch({
        type: MERGE_OPERATION_DATA,
        payload: { selectPath: ['login'], data: { entry: Entry.LOGIN } },
      });
      return dispatch(login());
    },
  };
};

export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(withFetchProductData(withSelectSkuId(ProductDetail)))
);
